import { Box, Typography } from '@mui/material';

import UpgradeToPremiumButton from '@/components/UpgradeToPremium/UpgradeToPremiumButton';

const PremiumFeatureMessage = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        pt: '74px',
        gap: 2,
        position: 'absolute',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        zIndex: 9,
        backdropFilter: 'blur(4px)',
        background: 'rgba(18, 22, 63, 0.30)'
      }}
    >
      <Typography
        sx={{ textAlign: 'center', fontWeight: 600 }}
        variant='h6'
      >
        This is a premium feature.
        <br />
        Upgrade for advanced functionality and exports.
      </Typography>
      <UpgradeToPremiumButton type='upgrade' />
    </Box>
  );
};

export default PremiumFeatureMessage;
